console.info("TDForm v3.18.0");
var TypeLocalization = {
  en: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  us: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  uk: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  ca: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  global: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  se: {
    0: "--Vänligen välj--",
    1: "AKK-användare eller anhörig",
    2: "Välgörenhet/Stiftelse/Organisation",
    3: "Utbildning",
    4: "Ekonomisk ersättning/finansiering/försäkring",
    5: "Hälso- och sjukvård",
    6: "TD-anställd",
    7: "TD-partner",
    8: "TD-leverantör",
    9: "Återförsäljare i Kina",
  },
  de: {
    0: "--Bitte wählen Sie--",
    1: "UK-Nutzer/in oder Angehörige",
    2: "Stiftung/ Organisation",
    3: "Kindergarten/ Schule/ Werkstatt",
    4: "Kostenträger/ Versicherung",
    5: "Therapie/ Pflege/ Medizin/ Beratung",
    6: "TD-Mitarbeiter",
    7: "TD-Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  no: {
    0: "--Vennligst velg--",
    1: "ASK-bruker eller omsorgsperson",
    2: "Veldedig organisasjon/stiftelse/organisasjon",
    3: "Utdanning/opplæring",
    4: "Økonomisk kompensasjon/finansiering/forsikring",
    5: "Helse- og medisinske tjenester",
    6: "TD-ansatt",
    7: "TD-partner",
    8: "TD-leverandør",
    9: "Forhandler i Kina",
  },
  fr: {
    0: "--Veuillez choisir--",
    1: "Utilisateur ou Soignant",
    2: "Association caritative/fondation/organisme",
    3: "Education",
    4: "Financement / Assurance",
    5: "Santé",
    6: "Employé TD",
    7: "Partenaire TD",
    8: "Fournisseur TD",
    9: "Revendeur en Chine",
  },
  es: {
    0: "--Por favor, elija--",
    1: "Usuario de CAA o cuidador",
    2: "Fundación u organización benéfica",
    3: "Educación",
    4: "Financiación/Seguros",
    5: "Salud",
    6: "Empleado de TD",
    7: "Partner de TD",
    8: "Proveedor de TD",
    9: "Distribuidor en China",
  },
  dk: {
    0: "--Vælg venligst--",
    1: "ASK-bruger eller omsorgsperson",
    2: "Velgørenhed/Fond/Organisation",
    3: "Uddannelse/træning",
    4: "Økonomisk kompensation/finansiering/forsikring",
    5: "Sundhed og lægehjælp",
    6: "TD-medarbejder",
    7: "TD-partner",
    8: "TD-leverandør",
    9: "Forhandler i Kina",
  },
  fi: {
    0: "--Ole hyvä ja valitse--",
    1: "AAC:n käyttäjä tai hoitaja",
    2: "Hyväntekeväisyysjärjestö/säätiö/organisaatio",
    3: "Koulutus",
    4: "Taloudellinen korvaus/rahoitus/vakuutus",
    5: "Terveyden- ja sairaanhoito",
    6: "TD:n työntekijä",
    7: "TD-kumppani",
    8: "TD-toimittaja",
    9: "Jälleenmyyjä Kiinassa",
  },
  it: {
    0: "--Si prega di scegliere--",
    1: "Utente CAA o Caregiver",
    2: "Ente di beneficenza/Fondazione/Organizzazione",
    3: "Istruzione",
    4: "Finanziatore/Assicurazione",
    5: "Healthcare",
    6: "Impiegato TD",
    7: "Partner TD",
    8: "Fornitore TD",
    9: "Rivenditore in Cina",
  },
  nl: {
    0: "--Maak een keuze--",
    1: "AAC-gebruiker of verzorger",
    2: "Liefdadigheidsinstelling/Stichting/Organisatie",
    3: "Onderwijs",
    4: "Financiering/Verzekering",
    5: "Gezondheidszorg",
    6: "TD-medewerker",
    7: "TD-partner",
    8: "TD-leverancier",
    9: "Chinese wederverkoper",
  },
  cn: {
    0: "--请选择--",
    1: "AAC用户或看护者",
    2: "慈善机构/基金会/公益组织",
    3: "教育",
    4: "资助/保险",
    5: "医疗保健",
    6: "TD员工",
    7: "TD合作伙伴",
    8: "TD供应商",
    9: "TD 中国经销商",
  },
  beta: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
  safecare: {
    0: "--Please Choose--",
    1: "AAC User or Caregiver",
    2: "Charity/Foundation/Organization",
    3: "Education",
    4: "Funding/Insurance",
    5: "Healthcare",
    6: "TD Employee",
    7: "TD Partner",
    8: "TD Supplier",
    9: "Chinese Reseller",
  },
};

var RoleLocalization = {
  en: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
  us: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
  uk: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
  ca: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
  global: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
  se: {
    0: "--Vänligen välj--",
    1: "AKK-användare",
    2: "AKK- specialist/hjälpmedelskonsulent",
    3: "Redovisning",
    4: "Administration",
    5: "Rådgivning och konsultation",
    6: "Revisionsverksamhet",
    7: "Förmånsrådgivning",
    8: "Affärsutveckling",
    9: "Handläggare",
    10: "Hantering av skadeärenden",
    11: "Kommunikation",
    12: "Konsult",
    13: "Rådgivning",
    14: "Kundservice",
    15: "Läkare eller specialistläkare",
    16: "Utvärderare (AKK)",
    17: "Verkställande ledning",
    18: "Specialist inom ögonsjukvård",
    19: "Familj",
    20: "Finans",
    21: "Tidigare Tobii Dynavox-anställd",
    22: "Insamling av finansiella medel",
    23: "Lärare",
    24: "Förvaltning av bidrag",
    25: "Försäkringsspecialist",
    26: "Försäkringsteckning",
    27: "IT",
    28: "Lärarassistent",
    29: "Juridik och regelefterlevnad",
    30: "Juridisk förmyndare",
    31: "Utlåning av AKK-enheter",
    32: "Ledning och styrning",
    33: "Produktion och tillverkning",
    34: "Marknadsföring",
    35: "Medicinskt ledarskap",
    36: "Sjuksköterska",
    37: "Arbetsterapi",
    38: "Orderhantering",
    39: "Annat",
    40: "Paramedicin",
    41: "Förälder",
    42: "Partner",
    43: "Fysioterapeut",
    44: "Fullmakt",
    45: "Förskoleverksamhet",
    46: "Projektledning",
    47: "Psykologi",
    48: "Inköpsverksamhet",
    49: "Rehabiliteringsingenjör",
    50: "Forskning",
    51: "Försäljning",
    52: "Syskon",
    53: "Speciallärare",
    54: "Logoped",
    55: "Make/maka",
    56: "Leverantör",
    57: "Lärare",
    58: "Teknisk support",
    59: "Tobii Dynavox-anställd",
    60: "Säljare",
    61: "Samordning av volontärarbete",
  },
  de: {
    0: "--Bitte wählen Sie--",
    1: "UK-Nutzer/in",
    2: "UK- oder AT-Spezialist/in",
    3: "Buchhaltung",
    4: "Verwaltung",
    5: "Beratung",
    6: "Prüfung",
    7: "Leistungsberatung",
    8: "Geschäftsentwicklung",
    9: "Fallmanagement",
    10: "Schadensmanagement",
    11: "Kommunikation",
    12: "Auftragnehmer",
    13: "Beratung",
    14: "Kundendienst",
    15: "Arzt, Ärztin",
    16: "Gutachter",
    17: "Führungsebene",
    18: "Orthoptist/in",
    19: "Familie",
    20: "Finanzen",
    21: "Ehemaliger Tobii Dynavox Mitarbeiter",
    22: "Spendensammlung",
    23: "Allgemeinbildender Lehrer",
    24: "Stipendienverwaltung",
    25: "Versicherungsspezialist",
    26: "Versicherungsunterzeichnung",
    27: "IT",
    28: "Persönliche/r Assistent/in",
    29: "Recht und Compliance",
    30: "Vormund",
    31: "Lending Library",
    32: "Management",
    33: "Herstellung",
    34: "Marketing",
    35: "Medizinische Leitung",
    36: "Krankenpfleger/in",
    37: "Ergotherapie",
    38: "Auftragsabwicklung",
    39: "Sonstiges",
    40: "Hilfskraft",
    41: "Elternteil",
    42: "Partner",
    43: "Physiotherapie",
    44: "Bevollmächtigter",
    45: "Erzieher/in",
    46: "Projektmanagement",
    47: "Psychologie",
    48: "Einkauf",
    49: "Rehabilitationstechnik",
    50: "Forschung",
    51: "Vertrieb",
    52: "Geschwister",
    53: "Lehrer/in/, Pädagoge, Pädagogin",
    54: "Logopädie, Sprachtherapie",
    55: "Ehepartner",
    56: "Lieferung",
    57: "Lehre",
    58: "Technischer Support",
    59: "Tobii Dynavox Mitarbeiter",
    60: "Vertriebsmitarbeiter",
    61: "Freiwilligenkoordination",
  },
  no: {
    0: "--Vennligst velg--",
    1: "ASK-bruker",
    2: "ASK-spesialist/hjelpemiddelkonsulent",
    3: "Regnskapsfører",
    4: "Administrasjon",
    5: "Rådgivning og konsultasjon",
    6: "Revisjon",
    7: "Rådgivning om ytelser",
    8: "Forretningsutvikling",
    9: "Skadebehandlere",
    10: "Håndtering av krav",
    11: "Kommunikasjonstjenester",
    12: "Konsulent",
    13: "Rådgivning",
    14: "Kundeservice",
    15: "Lege eller spesialist",
    16: "Evaluator (ASK)",
    17: "Ledelse",
    18: "Øyelege",
    19: "Familie",
    20: "Økonomi",
    21: "Tidligere ansatt i Tobii Dynavox",
    22: "Innsamling av penger",
    23: "Lærer",
    24: "Forvaltning av tilskudd",
    25: "Forsikringsrådgiver",
    26: "Forsikringstegning",
    27: "IT-spesialist",
    28: "Undervisningsassistent",
    29: "Juridisk og compliance",
    30: "Juridisk verge",
    31: "Utlån av ASK-hjelpemidler",
    32: "Ledelse og styring",
    33: "Produksjon og fremstilling",
    34: "Markedsføring og kommersialisering",
    35: "Medisinsk ledelse",
    36: "Sykepleier",
    37: "Ergoterapi",
    38: "Ordrehåndtering",
    39: "Annet",
    40: "Paramedisin",
    41: "Foreldre",
    42: "Partner",
    43: "Fysioterapeut",
    44: "Fullmakt",
    45: "Førskolevirksomhet",
    46: "Prosjektledelse",
    47: "Psykologi",
    48: "Innkjøpsvirksomhet",
    49: "Rehabiliteringsingeniør",
    50: "Forskning og utvikling",
    51: "Salg og markedsføring",
    52: "Søsken",
    53: "Spesialpedagog skole",
    54: "Logoped",
    55: "Ektefelle",
    56: "Leverandør",
    57: "Lærer",
    58: "Teknisk support",
    59: "Tobii Dynavox-ansatt",
    60: "Selgere",
    61: "Koordinering av frivillig arbeid",
  },
  fr: {
    0: "--Veuillez choisir--",
    1: "Utilisateur de CAA",
    2: "Spécialiste des aides techniques ou de CAA",
    3: "Comptabilité",
    4: "Administration",
    5: "Conseil et assistance",
    6: "Audit",
    7: "Conseil sur les avantages sociaux",
    8: "Développement commercial",
    9: "Gestion des dossiers",
    10: "Gestion des réclamations",
    11: "Communications",
    12: "Prestataire",
    13: "Conseiller",
    14: "Services client",
    15: "Médecin ou praticien spécialisé",
    16: "Evaluateur",
    17: "Direction d'entreprise",
    18: "Spécialiste des soins ophtalmologiques",
    19: "Famille",
    20: "Finance",
    21: "Ancien employé de Tobii Dynavox",
    22: "Collecte de fonds",
    23: "Enseignement général",
    24: "Gestion des subventions",
    25: "Spécialiste en assurance",
    26: "Souscription d'assurance",
    27: "IT (Informatique)",
    28: "Assistant d'apprentissage",
    29: "Juridique et conformité",
    30: "Tuteur légal",
    31: "bibliothèque de prêt",
    32: "Gestion",
    33: "Production",
    34: "Marketing",
    35: "Management du personnel médical",
    36: "Infirmier",
    37: "Ergothérapie",
    38: "Traitement des commandes",
    39: "Autre",
    40: "Paraprofessionnel",
    41: "Parent",
    42: "Partenaire",
    43: "kinésithérapie",
    44: "Procuration",
    45: "Éducation préscolaire",
    46: "Gestion de projet",
    47: "Psychologie",
    48: "Achats",
    49: "Ingénierie de la réhabilitation",
    50: "Recherche",
    51: "Ventes",
    52: "Frère ou sœur",
    53: "Enseignement spécialisé",
    54: "Orthophonie",
    55: "Conjoint(e)",
    56: "Fournisseur",
    57: "Enseignement",
    58: "Support technique",
    59: "Employé Tobii Dynavox",
    60: "Commercial",
    61: "Volontariat",
  },
  es: {
    0: "--Por favor, elija--",
    1: "Usuario de CAA",
    2: "Especialista en CAA o tecnologías de apoyo",
    3: "Contabilidad",
    4: "Administración",
    5: "Asesoría y consultoría",
    6: "Auditoría",
    7: "Asesoría de beneficios",
    8: "Desarrollo de negocio",
    9: "Gestión de casos",
    10: "Gestión de reclamaciones",
    11: "Comunicación",
    12: "Contratista",
    13: "Asesoramiento",
    14: "Atención al cliente",
    15: "Doctor o médico especialista",
    16: "Evaluador",
    17: "Dirección ejecutiva",
    18: "Oftalmólogo",
    19: "Familia",
    20: "Finanzas",
    21: "Antiguo empleado de TD",
    22: "Recaudación de fondos",
    23: "Profesor",
    24: "Gestión de subvenciones",
    25: "Especialista en seguros",
    26: "Evaluación de riesgos para seguros",
    27: "Informático/a",
    28: "Asistente de aprendizaje",
    29: "Asuntos legales y cumplimiento",
    30: "Tutor legal",
    31: "Biblioteca de préstamo",
    32: "Gestión",
    33: "Producción",
    34: "Marketing",
    35: "Dirección médica",
    36: "Enfermero/a especialista",
    37: "Terapeuta ocupacional",
    38: "Gestión de pedidos",
    39: "Otro",
    40: "Paraprofesional",
    41: "Padre o madre",
    42: "Pareja",
    43: "Fisioterapeuta",
    44: "Representante",
    45: "Educación preescolar",
    46: "Gestión de proyectos",
    47: "Psicólogo/a",
    48: "Compras",
    49: "Ingeniería de rehabilitación",
    50: "Investigador/a",
    51: "Ventas",
    52: "Hermano/a",
    53: "Profesor/a de educación especial",
    54: "Logopeda / Fonoaudiólogo/a",
    55: "Esposa",
    56: "Suministros",
    57: "Educador/a",
    58: "Soporte técnico",
    59: "Empleado de TD",
    60: "Representante de ventas",
    61: "Voluntario/a",
  },
  dk: {
    0: "--Vælg venligst--",
    1: "ASK-bruger",
    2: "ASK-specialist/konsulent i hjælpemiddelteknologi",
    3: "Bogholderi",
    4: "Administration",
    5: "Konsulent- og rådgivningsydelser",
    6: "Revisionsaktiviteter",
    7: "Rådgivning om fordele",
    8: "Forretningsudvikling",
    9: "Sagsbehandler",
    10: "Håndtering af krav",
    11: "Kommunikationstjenester",
    12: "Rådgivning",
    13: "Rådgivning",
    14: "Kundeservice",
    15: "Læge eller specialist",
    16: "Evaluator (ASK)",
    17: "Ledende medarbejder",
    18: "Specialist i øjensygdomme",
    19: "Familie",
    20: "Økonomi",
    21: "Tidligere ansat hos Tobii Dynavox",
    22: "Finansiel fundraising",
    23: "Lærer",
    24: "Forvaltning af tilskud",
    25: "Forsikringsspecialist",
    26: "Forsikringstegning",
    27: "IT",
    28: "Undervisningsassistent",
    29: "Jura og compliance",
    30: "Juridisk værge",
    31: "Udlån af hjælpemidler",
    32: "Ledelse og styring",
    33: "Produktion og fremstilling",
    34: "Markedsføring og kommercialisering",
    35: "Medicinsk ledelse",
    36: "Sygepleje",
    37: "Ergoterapi",
    38: "Håndtering af ordrer",
    39: "Andet",
    40: "Paramedicin",
    41: "Forældre",
    42: "Partner",
    43: "Fysioterapeut",
    44: "Fuldmagt",
    45: "Førskoleaktiviteter",
    46: "Projektledelse",
    47: "Psykologi",
    48: "Indkøbsaktiviteter",
    49: "Rehabiliteringsingeniør",
    50: "Forskning og udvikling",
    51: "Salg og markedsføring",
    52: "Søskende",
    53: "Specialærer",
    54: "Logopæd",
    55: "Ægtefælle",
    56: "Leverandør",
    57: "Undervisning",
    58: "Teknisk support",
    59: "Tobii Dynavox-medarbejder",
    60: "Sælger",
    61: "Koordinering af frivilligt arbejde",
  },
  fi: {
    0: "--Ole hyvä ja valitse--",
    1: "AAC-käyttäjä",
    2: "AAC-asiantuntija/apuvälineteknologian asiantuntija",
    3: "Kirjanpito",
    4: "Hallinto",
    5: "Konsultointi- ja neuvontapalvelut",
    6: "Tilintarkastustoiminta",
    7: "Etuuksia koskeva neuvonta",
    8: "Yritystoiminnan kehittäminen",
    9: "Asiankäsittelijä",
    10: "Korvausten hallinnointi",
    11: "Viestintäpalvelut",
    12: "Konsultointi",
    13: "Neuvonta",
    14: "Asiakaspalvelu",
    15: "Lääkäri tai asiantuntija",
    16: "Arvioija",
    17: "Toimeenpaneva johto",
    18: "Silmäterveydenhuollon asiantuntija",
    19: "Perhe",
    20: "Talous",
    21: "Entinen Tobii Dynavoxin työntekijä",
    22: "Varainhankinta",
    23: "Opettaja",
    24: "Etuuksien hallinnointi",
    25: "Vakuutusasiantuntija",
    26: "Vakuutusten ottaminen",
    27: "IT-asiantuntija",
    28: "Opetusavustaja",
    29: "Lainsäädäntö ja säännösten noudattaminen",
    30: "Oikeudellinen edunvalvoja",
    31: "Kommunikointilaitteiden lainaaminen",
    32: "Hallinto",
    33: "Tuotanto ja valmistus",
    34: "Markkinointi ja kaupallistaminen",
    35: "Lääketieteellinen johtaminen",
    36: "Hoitotyö",
    37: "Toimintaterapia",
    38: "Tilausten hallinta",
    39: "Muut alat",
    40: "Ensihoito",
    41: "Vanhempi",
    42: "Kumppani",
    43: "Fysioterapeutti",
    44: "Edunvalvoja",
    45: "Esikoulun toiminta",
    46: "Projektinhallinta",
    47: "Psykologia",
    48: "Ostotoiminta",
    49: "Kuntoutusinsinööri",
    50: "Tutkimus ja kehittäminen",
    51: "Myynti ja markkinointi",
    52: "Sisarus",
    53: "Erityisopettaja",
    54: "Puheterapeutti",
    55: "Puoliso",
    56: "Tavarantoimittaja",
    57: "Opettaja",
    58: "Tekninen tuki",
    59: "Tobii Dynavoxin työntekijä",
    60: "Myyntiedustaja",
    61: "Vapaaehtoistyön koordinoija",
  },
  it: {
    0: "--Si prega di scegliere--",
    1: "Utente CAA",
    2: "Esperto di CAA o Tecnologie assistive",
    3: "Contabile",
    4: "Ammistrativo",
    5: "Consulente",
    6: "Revisore",
    7: "Benefits Advisory",
    8: "Sviluppo aziendale",
    9: "Case management",
    10: "Gestione reclami",
    11: "Comunicazioni",
    12: "Appaltatore",
    13: "Counceling",
    14: "Servizio clienti",
    15: "Medico o medico specialista",
    16: "Valutatore",
    17: "Dirigente esecutivo",
    18: "Oculista/Ortottista",
    19: "Familiare",
    20: "Finanza",
    21: "Ex dipendente TD",
    22: "Raccolta Fondi",
    23: "Insegnante",
    24: "Gestione finanziamenti",
    25: "Specialista assicurativo",
    26: "Sottoscrizione assicurativa",
    27: "IT",
    28: "Assistente alla comunicazione",
    29: "Legale e conformità",
    30: "Tutore legale",
    31: "Bibliotecario",
    32: "Management",
    33: "Produzione",
    34: "Marketing",
    35: "Dirigente medico",
    36: "Infermiere specializzato",
    37: "Terapista occupazionale",
    38: "Elaborazione ordini",
    39: "Altro",
    40: "Paraprofessionista",
    41: "Genitore",
    42: "Compagno",
    43: "Fisioterapista",
    44: "Avente procura",
    45: "Educatore prescolare",
    46: "Gestione progetti",
    47: "Psicologo",
    48: "Acquisti",
    49: "Ingegneria riabilitativa",
    50: "Ricerca",
    51: "Vendita",
    52: "Fratello",
    53: "Insegnante di sostegno",
    54: "Logopedista",
    55: "Coniuge",
    56: "Fornitore",
    57: "Insegnante",
    58: "Supporto tecnico",
    59: "Dipendente Tobii Dynavox",
    60: "Rappresentante di vendita",
    61: "Coordinatore volontari",
  },
  nl: {
    0: "--Maak een keuze--",
    1: "AAC-gebruiker",
    2: "AAC- of AT-specialist",
    3: "Boekhouding",
    4: "Administratie",
    5: "Advies en consultancy",
    6: "Auditing",
    7: "Voordelenadvies",
    8: "Bedrijfsontwikkeling",
    9: "Casemanagement",
    10: "Claimbeheer",
    11: "Communicatie",
    12: "Aannemer",
    13: "Counseling",
    14: "Klantenservice",
    15: "Dokter of specialist",
    16: "Evaluator",
    17: "Uitvoerend leiderschap",
    18: "Oogzorgspecialist",
    19: "Familie",
    20: "Financiën",
    21: "Voormalig Tobii Dynavox-medewerker",
    22: "Fondsenwerving",
    23: "Algemeen onderwijzer",
    24: "Subsidiebeheer",
    25: "Verzekeringsspecialist",
    26: "Verzekeringsacceptatie",
    27: "IT",
    28: "Leerassistent",
    29: "Juridisch en naleving",
    30: "Wettelijke voogd",
    31: "Uitleenbibliotheek",
    32: "Management",
    33: "Productie",
    34: "Marketing",
    35: "Medisch leiderschap",
    36: "Verpleegkundig specialist",
    37: "Ergotherapie",
    38: "Orderverwerking",
    39: "Anders",
    40: "Onderwijsassistent",
    41: "Ouder",
    42: "Partner",
    43: "Fysiotherapie",
    44: "Volmacht",
    45: "Voorschoolse educatie",
    46: "Projectmanagement",
    47: "Psychologie",
    48: "Inkoop",
    49: "Revalidatietechniek",
    50: "Onderzoek",
    51: "Verkoop",
    52: "Broer of zus",
    53: "Speciaal onderwijzer",
    54: "Logopedie",
    55: "Echtgenoot/echtgenote",
    56: "Levering",
    57: "Onderwijs",
    58: "Technische ondersteuning",
    59: "Tobii Dynavox-medewerker",
    60: "Vertegenwoordiger",
    61: "Vrijwilligerscoördinatie",
  },
  cn: {
    0: "--请选择--",
    1: "AAC用户",
    2: "AAC或辅助沟通技术专家",
    3: "会计",
    4: "行政",
    5: "咨询和顾问",
    6: "审计",
    7: "福利顾问",
    8: "业务发展",
    9: "个案管理",
    10: "理赔管理",
    11: "通信",
    12: "承包商",
    13: "咨询",
    14: "客户服务",
    15: "医生或专科医生",
    16: "评估师",
    17: "高层管理者",
    18: "眼科护理专家",
    19: "家庭成员",
    20: "财务",
    21: "前Tobii Dynavox员工",
    22: "筹款/募捐",
    23: "普通教育教师",
    24: "拨款管理",
    25: "保险专员",
    26: "保险承保",
    27: "信息技术",
    28: "学习助理",
    29: "法律和合规",
    30: "法定监护人",
    31: "图书馆借阅",
    32: "管理",
    33: "制造商",
    34: "市场营销",
    35: "医疗领导",
    36: "执业护士",
    37: "职业治疗",
    38: "订单处理",
    39: "其他",
    40: "助教",
    41: "家长",
    42: "合作伙伴",
    43: "物理治疗",
    44: "代理人",
    45: "学前教育",
    46: "项目管理",
    47: "心理学",
    48: "采购",
    49: "康复工程",
    50: "研究",
    51: "销售",
    52: "兄弟姐妹",
    53: "特殊教育教师",
    54: "言语语言病理学/治疗师",
    55: "配偶",
    56: "供应商",
    57: "教学",
    58: "技术支持",
    59: "Tobii Dynavox员工",
    60: "销售代表",
    61: "志愿者协调",
  },
  beta: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
  safecare: {
    0: "--Please Choose--",
    1: "AAC User",
    2: "AAC or AT Specialist",
    3: "Accounting",
    4: "Administration",
    5: "Advisory and Consultancy",
    6: "Auditing",
    7: "Benefits Advisory",
    8: "Business Development",
    9: "Case Management",
    10: "Claims Management",
    11: "Communications",
    12: "Contractor",
    13: "Counceling",
    14: "Customer services",
    15: "Doctor or Specialist Physician",
    16: "Evaluator",
    17: "Executive Leadership",
    18: "Eye Care Specialist",
    19: "Family",
    20: "Finance",
    21: "Former Tobii Dynavox Employee",
    22: "Fundraising",
    23: "General Education Teacher",
    24: "Grant Management",
    25: "Insurance Specialist",
    26: "Insurance Underwriting",
    27: "IT",
    28: "Learning Assistant",
    29: "Legal and Compliance",
    30: "Legal Guardian",
    31: "Lending Library",
    32: "Management",
    33: "Manufacturing",
    34: "Marketing",
    35: "Medical Leadership",
    36: "Nurse Practitioner",
    37: "Occupational Therapy",
    38: "Order Processing",
    39: "Other",
    40: "Paraprofessional",
    41: "Parent",
    42: "Partner",
    43: "Physical Therapy",
    44: "Power of Attorney",
    45: "Preschool Education",
    46: "Project management",
    47: "Psychology",
    48: "Purchasing",
    49: "Rehabilitation Engineering",
    50: "Research",
    51: "Sales",
    52: "Sibling",
    53: "Special Education Teacher",
    54: "Speech Language Pathology/Therapy",
    55: "Spouse",
    56: "Supply",
    57: "Teaching",
    58: "Technical Support",
    59: "Tobii Dynavox Employee",
    60: "Sales Representative",
    61: "Volunteer coordination",
  },
};

var Variations = {
  en: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 31, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 6, 7, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  us: {
    Type: [0, 1, 2, 3, 4, 5],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 31, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 47, 48, 53, 54],
      [0, 3, 4, 6, 7, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 39, 43, 48, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  uk: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  ca: {
    Type: [0, 1, 2, 3, 4, 5],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 31, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 47, 48, 53, 54],
      [0, 3, 4, 6, 7, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 39, 43, 48, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  global: {
    Type: [0, 1, 2, 3, 4, 5],
    Role: [
      [0],
      [0, 1, 19, 30, 41, 42, 44, 52, 55, 39],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 46, 50, 61, 39],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 40, 43, 47, 48, 53, 54, 39],
      [0, 3, 4, 6, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 43, 48, 54, 57, 39],
    ],
  },
  se: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  dk: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  de: {
    Type: [0, 1, 2, 3, 4, 5],
    Role: [
      [0],
      [0, 1, 19, 30, 41, 42, 44, 52, 55, 39],
      [0, 4, 5, 11, 22, 27, 32, 34, 50, 61, 39],
      [0, 2, 4, 27, 28, 40, 45, 48, 49, 53, 39],
      [0, 3, 4, 9, 10, 39],
      [0, 2, 15, 18, 27, 32, 35, 36, 37, 43, 48, 49, 54, 39],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 43, 51, 54, 58, 39],
      [0, 2, 4, 17, 20, 33, 34, 37, 43, 51, 54, 56, 39],
      [0, 2, 4, 17, 20, 27, 34, 37, 43, 51, 54, 39],
    ],
  },
  no: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  fr: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  es: {
    Type: [0, 1, 2, 3, 5],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [
        0, 2, 4, 5, 8, 11, 14, 15, 16, 17, 20, 22, 23, 27, 29, 32, 34, 36, 37,
        39, 43, 46, 47, 50, 53, 54, 61,
      ],
      [0, 2, 4, 13, 17, 23, 27, 28, 37, 39, 40, 43, 45, 47, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 15, 17, 18, 27, 32, 35, 36, 37, 39, 43, 47, 48, 49, 50, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  cn: {
    Type: [0, 1, 2, 3, 4, 5, 7],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 45, 47, 48, 49, 53, 54],
      [0, 3, 4, 9, 10, 20, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 37, 39, 43, 48, 49, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  beta: {
    Type: [0, 1, 2, 3, 5],
    Role: [
      [0],
      [0, 1, 39, 41, 42, 55],
      [0, 16, 31, 39],
      [0, 2, 23, 37, 39, 43, 45, 53, 54],
      [0, 3, 4, 6, 7, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 37, 39, 43, 54],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  safecare: {
    Type: [0, 1, 3, 5],
    Role: [
      [0],
      [0, 1, 19, 39],
      [0, 16, 31, 39],
      [0, 2, 23, 28, 37, 39, 53, 54],
      [0, 3, 4, 6, 7, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 37, 39, 54],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
  td_snap_enterprise: {
    Type: [0, 2, 3, 5],
    Role: [
      [0],
      [0, 1, 19, 30, 39, 41, 42, 44, 52, 55],
      [0, 4, 5, 8, 11, 14, 16, 17, 20, 22, 27, 29, 31, 32, 34, 39, 46, 50, 61],
      [0, 2, 4, 13, 17, 20, 23, 27, 28, 37, 39, 40, 43, 47, 48, 53, 54],
      [0, 3, 4, 6, 7, 9, 10, 20, 25, 26, 29, 39],
      [0, 2, 4, 15, 17, 18, 20, 27, 32, 35, 36, 39, 43, 48, 54, 57],
      [0, 12, 21, 59, 60],
      [0, 2, 4, 17, 20, 27, 34, 37, 38, 39, 43, 51, 54, 58],
      [0, 2, 4, 17, 20, 33, 34, 37, 39, 43, 51, 54, 56],
      [0, 2, 4, 17, 20, 27, 34, 37, 39, 43, 51, 54],
    ],
  },
};

var AdultChildOptionShownByRoles = [1, 3, 5];

class TypeRole {
  ListItem = class ListItem {
    constructor(id, value, text, relatedItems) {
      this.Id = id;
      this.Value = value;
      this.Text = text;
      this.RelatedItems = relatedItems;
    }
  };
  LocalizationItem = class LocalizationItem {
    constructor(id, languageCode, text) {
      this.Id = id;
      this.Code = languageCode;
      this.Text = text;
    }
  };

  TypesBase = [
    new this.ListItem(0, "", ""),
    new this.ListItem(1, "AAC User or Caregiver", ""),
    new this.ListItem(2, "Charity/Foundation/Organization", ""),
    new this.ListItem(3, "Education", ""),
    new this.ListItem(4, "Funding/Insurance", ""),
    new this.ListItem(5, "Healthcare", ""),
    new this.ListItem(6, "TD Employee", ""),
    new this.ListItem(7, "TD Partner", ""),
    new this.ListItem(8, "TD Supplier", ""),
    new this.ListItem(9, "Chinese Reseller", ""),
  ];

  Types = [];

  Roles = [
    new this.ListItem(0, "", ""),
    new this.ListItem(1, "AAC User", ""),
    new this.ListItem(2, "AAC or AT Specialist", ""),
    new this.ListItem(3, "Accounting", ""),
    new this.ListItem(4, "Administration", ""),
    new this.ListItem(5, "Advisory and Consultancy", ""),
    new this.ListItem(6, "Auditing", ""),
    new this.ListItem(7, "Benefits Advisory", ""),
    new this.ListItem(8, "Business Development", ""),
    new this.ListItem(9, "Case Management", ""),
    new this.ListItem(10, "Claims Management", ""),
    new this.ListItem(11, "Communications", ""),
    new this.ListItem(12, "Contractor", ""),
    new this.ListItem(13, "Counceling", ""),
    new this.ListItem(14, "Customer services", ""),
    new this.ListItem(15, "Doctor or Specialist Physician", ""),
    new this.ListItem(16, "Evaluator", ""),
    new this.ListItem(17, "Executive Leadership", ""),
    new this.ListItem(18, "Eye Care Specialist", ""),
    new this.ListItem(19, "Family", ""),
    new this.ListItem(20, "Finance", ""),
    new this.ListItem(21, "Former Tobii Dynavox Employee", ""),
    new this.ListItem(22, "Fundraising", ""),
    new this.ListItem(23, "General Education Teacher", ""),
    new this.ListItem(24, "Grant Management", ""),
    new this.ListItem(25, "Insurance Specialist", ""),
    new this.ListItem(26, "Insurance Underwriting", ""),
    new this.ListItem(27, "IT", ""),
    new this.ListItem(28, "Learning Assistant", ""),
    new this.ListItem(29, "Legal and Compliance", ""),
    new this.ListItem(30, "Legal Guardian", ""),
    new this.ListItem(31, "Lending Library", ""),
    new this.ListItem(32, "Management", ""),
    new this.ListItem(33, "Manufacturing", ""),
    new this.ListItem(34, "Marketing", ""),
    new this.ListItem(35, "Medical Leadership", ""),
    new this.ListItem(36, "Nurse Practitioner", ""),
    new this.ListItem(37, "Occupational Therapy", ""),
    new this.ListItem(38, "Order Processing", ""),
    new this.ListItem(39, "Other", ""),
    new this.ListItem(40, "Paraprofessional", ""),
    new this.ListItem(41, "Parent", ""),
    new this.ListItem(42, "Partner", ""),
    new this.ListItem(43, "Physical Therapy", ""),
    new this.ListItem(44, "Power of Attorney", ""),
    new this.ListItem(45, "Preschool Education", ""),
    new this.ListItem(46, "Project management", ""),
    new this.ListItem(47, "Psychology", ""),
    new this.ListItem(48, "Purchasing", ""),
    new this.ListItem(49, "Rehabilitation Engineering", ""),
    new this.ListItem(50, "Research", ""),
    new this.ListItem(51, "Sales", ""),
    new this.ListItem(52, "Sibling", ""),
    new this.ListItem(53, "Special Education Teacher", ""),
    new this.ListItem(54, "Speech Language Pathology/Therapy", ""),
    new this.ListItem(55, "Spouse", ""),
    new this.ListItem(56, "Supply", ""),
    new this.ListItem(57, "Teaching", ""),
    new this.ListItem(58, "Technical Support", ""),
    new this.ListItem(59, "Tobii Dynavox Employee", ""),
    new this.ListItem(60, "Sales Representative", ""),
    new this.ListItem(61, "Volunteer coordination", ""),
  ];
  constructor(langCode, variation = null) {
    let typeRoleSetup = [];
    if (variation === null) {
      //support for legacy code
      typeRoleSetup = Variations[langCode];
    } else {
      typeRoleSetup = Variations[variation];
      if (!typeRoleSetup) console.error(`Variation ${variation} not found`);
    }

    typeRoleSetup["Type"].forEach((typeId) => {
      this.Types.push(
        new this.ListItem(
          typeId,
          this.TypesBase[typeId].Value,
          "-",
          typeRoleSetup["Role"][typeId]
        )
      );
    });

    this.TranslateTypes(langCode);
    this.TranslateRoles(langCode);
  }
  TranslateTypes(langCode) {
    this.Types.forEach((type) => {
      let localItem = TypeLocalization[langCode][type.Id];
      if (localItem) {
        type.Text = localItem;
      } else {
        type.Text = `[missing translation: ${type.Text}]`;
      }
    });
  }
  TranslateRoles(langCode) {
    this.Roles.forEach((role) => {
      let localItem = RoleLocalization[langCode][role.Id];
      if (localItem) {
        role.Text = localItem;
      } else {
        role.Text = `[missing translation: ${role.Text}]`;
      }
    });
  }
  GetTypes() {
    return this.Types;
  }
  GetRoles(type) {
    let relatedRoles = [];
    if (!type) return relatedRoles;
    type.RelatedItems?.forEach((relatedItem) => {
      let role = this.Roles.find((r) => r.Id === relatedItem);
      if (role) {
        relatedRoles.push(role);
      }
    });

    return relatedRoles;
  }
  GetRolesById(typeId) {
    let type = null;
    this.Types.forEach((t) => {
      if (t.Id === typeId) {
        type = t;
      }
    });
    return this.GetRoles(type);
  }
  GetRolesByName(typeValue) {
    let type = null;
    this.Types.forEach((t) => {
      if (t.Value === typeValue) {
        type = t;
      }
    });
    return this.GetRoles(type);
  }
}

if (typeof TDForm === "undefined") {
  var TDForm = {
    currentRegion: "",
    defaultRegion: "global",
    TypeRole: null,
    private: {
      showField: function (fieldId) {
        document.getElementById(fieldId)?.classList.remove("hidden");
      },
      hideField: function (fieldId) {
        document.getElementById(fieldId)?.classList.add("hidden");
      },
      MakeFieldMandatory: function (fieldId) {
        document.getElementById(fieldId).setAttribute("required", "");
      },
      RemoveFieldMandatory: function (fieldId) {
        document.getElementById(fieldId).removeAttribute("required");
      },
      ClearSelectOptions: function (selectId) {
        let select = document.getElementById(selectId);
        select.innerHTML = "";
      },
      CreateTypeOptions: function (selectId) {
        TDForm.private.ClearSelectOptions(selectId);
        let select = document.getElementById(selectId);
        let types = TDForm.TypeRole.GetTypes();
        types.forEach((type) => {
          let option = document.createElement("option");
          option.value = type.Value;
          option.innerHTML = type.Text;
          select.appendChild(option);
        });
      },
      CreateRoleOptions: function (selectId, typeValue) {
        TDForm.private.ClearSelectOptions(selectId);
        let select = document.getElementById(selectId);
        let relatedRoles = TDForm.TypeRole.GetRolesByName(typeValue);
        relatedRoles.forEach((role) => {
          let option = document.createElement("option");
          option.value = role.Value;
          option.innerHTML = role.Text;
          select.appendChild(option);
        });
      },
      addMultiSelectListener: function () {
        const options = document.querySelectorAll(
          ".form-style select[multiple] option"
        );
        if (options.length > 0) {
          options.forEach((option) => {
            option.addEventListener("mousedown", function (e) {
              var el = e.target;
              e.preventDefault();
              el.parentElement.focus();
              this.selected = !this.selected;
              var scrollTop = el.parentNode.scrollTop;
              setTimeout(() => el.parentNode.scrollTo(0, scrollTop), 0);
              return false;
            });
          });
        }
      },
    },
    helper: {
      showField: function (fieldId, isRequired = false) {
        if (isRequired) {
          let container = document.getElementById(fieldId)?.closest("div");
          container.querySelector("label")?.classList.add("required");
          container?.classList.remove("hidden");

          if (container.querySelector("input")) {
            container.querySelectorAll("input").forEach((el) => {
              el.setAttribute("required", "");
            });
          } else if (container.querySelector("select")) {
            container.querySelector("select").setAttribute("required", "");
          } else if (container.querySelector("textarea")) {
            container.querySelector("textarea").setAttribute("required", "");
          }
        } else {
          document
            .getElementById(fieldId)
            ?.closest("div")
            ?.classList.remove("hidden");
        }
      },
      hideField: function (fieldId) {
        let container = document.getElementById(fieldId)?.closest("div");
        container?.classList.add("hidden");
        container?.querySelector("label")?.classList.remove("required");

        if (container.querySelector("input")) {
          container.querySelectorAll("input").forEach((el) => {
            el.removeAttribute("required");
          });
        } else if (container.querySelector("select")) {
          container.querySelector("select").removeAttribute("required");
        } else if (container.querySelector("textarea")) {
          container.querySelector("textarea").removeAttribute("required");
        }

        if (container.querySelector('[type="Radio"]')) {
          if (document.querySelector(`[name="${fieldId}"]:checked`)) {
            document.querySelector(
              `[name="${fieldId}"]:checked`
            ).checked = false;
          }
        } else {
          document.getElementById(fieldId).value = "";
        }
      },
      updateSelect: function (selectId, items) {
        let select = document.getElementById(selectId);
        select.innerHTML = "";

        let option = document.createElement("option");
        option.value = "";
        option.innerHTML = "--please select--";
        select.appendChild(option);

        items.forEach((item) => {
          let option = document.createElement("option");
          if (item?.value !== undefined) {
            option.value = item.value;
            option.innerHTML = item.name;
          } else {
            option.value = item;
            option.innerHTML = item;
          }
          select.appendChild(option);
        });
      },
      errorCheckURL: function parseQueryStringFromURL() {
        let url = window.location.href;
        let queryString = url.split("?")[1];
        let pairs = queryString.split("&");
        let result = {};

        pairs.forEach((pair) => {
          let [key, value] = pair.split("=");
          key = decodeURIComponent(key);
          value = decodeURIComponent(value || "");
          result[key] = value;
        });

        return result;
      },
      errorCheck: function parseQueryStringFromURL() {
        let queryString = document.getElementById("errorMessage")?.value;
        if (!queryString) return {};
        let pairs = queryString.split("&");
        let result = {};

        pairs.forEach((pair) => {
          let [key, value] = pair.split("=");
          key = decodeURIComponent(key);
          value = decodeURIComponent(value || "");
          result[key] = value;
        });

        return result;
      },
      showSection: function (sectionId) {
        document.getElementById(sectionId)?.classList.remove("hidden");
      },
      hideSection: function (sectionId) {
        document.getElementById(sectionId)?.classList.add("hidden");
      },
      getDescription: function (isRichFormat = false) {
        let newLine = "\r\n";
        let description = "";
        let descriptionFields = document.querySelectorAll(".description");
        descriptionFields.forEach((field) => {
          if (field.querySelector("button")) {
            //accordion item
            if (field.querySelector('input[type="file"]').getAttribute("url")) {
              description += !isRichFormat
                ? "<<" + field.querySelector("button").innerText + ">>"
                : "<strong>" +
                  field.querySelector("button").innerText +
                  "</strong>";
              description += newLine;
            }
          } else if (field.querySelector("select:not([multiple])")) {
            //single select
            if (field.querySelector("select").selectedOptions[0]?.value) {
              description += !isRichFormat
                ? "Q: "+field.querySelector("label").innerText
                : "<strong>" +
                  field.querySelector("label").innerText +
                  "</strong>";
              description += newLine;
              description +=
                "A: "+field.querySelector("select").selectedOptions[0].value +
                newLine + newLine;
            }
          } else if (field.querySelector("select[multiple]")) {
              //multiple select
              if (field.querySelector("select").selectedOptions[0]?.value) {
                description += !isRichFormat
                  ? "Q: "+field.querySelector("label").innerText
                  : "<strong>" +
                    field.querySelector("label").innerText +
                    "</strong>";
                description += newLine + "A: ";
                field
                  .querySelector("select")
                  .selectedOptions.forEach((option) => {
                    description += option.value + ", ";
                  });
                description = description.slice(0, -2); // Remove the last comma and space
                description += newLine + newLine;
              }
          } else if (field.querySelector('input[type="text"]')) {
            //text field
            if (field.querySelector("input").value) {
              description += !isRichFormat
                ? "Q: "+field.querySelector("label").innerText
                : "<strong>" +
                  field.querySelector("label").innerText +
                  "</strong>";
              description += newLine;
              description += "A: "+field.querySelector("input").value + newLine + newLine;
            }
          }else if(field.querySelector('input[type="url"]')){
            //url field
            if (field.querySelector("input").value) {
              description += !isRichFormat
                ? "Q: "+field.querySelector("label").innerText
                : "<strong>" +
                  field.querySelector("label").innerText +
                  "</strong>";
              description += newLine;
              description += "A: "+field.querySelector("input").value + newLine + newLine;
            }

          }else if (field.querySelector('input[type="number"]')) {
            //number field
            if (field.querySelector("input").value) {
              let label= field.querySelector("input").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description += "A: "+field.querySelector("input").value + newLine + newLine;
            }
          } else if (field.querySelector('input[type="radio"]')) {
            //radio group
            if (field.querySelector('input[type="radio"]:checked')?.value) {
              description += !isRichFormat
                ? "Q: "+field.querySelector("label").innerText
                : "<strong>" +
                  field.querySelector("label").innerText +
                  "</strong>";
              description += newLine;
              description +=
                "A: "+field.querySelector('input[type="radio"]:checked')?.value +
                newLine + newLine;
            }
          } else if (field.querySelector("textarea")) {
            //textarea
            if (field.querySelector("textarea").value) {
              description += !isRichFormat
                ? "Q: "+field.querySelector("label").innerText
                : "<strong>" +
                  field.querySelector("label").innerText +
                  "</strong>";
              description += newLine;
              description += "A: "+field.querySelector("textarea").value + newLine+ newLine;
            }
          } else if (field.querySelector('input[type="file"]')) {
            //file input
            if (field.querySelector('input[type="file"]').getAttribute("url")) {
              if (isRichFormat) {
                description +=
                  `<a href="${field
                    .querySelector('input[type="file"]')
                    .getAttribute("url")}" target="_blank">${
                    field.querySelector("label").innerText
                  }</a>` + newLine;
              } else {
                description += "Q: "+field.querySelector("label").innerText + newLine;
                description +=
                  "A: "+field
                    .querySelector('input[type="file"]')
                    .getAttribute("url") + newLine+ newLine;
              }
            }
          } else {
            description += "this field is not supported" + newLine;
            description += field.innerHTML;
          }
        });

        if (description === "") description = "No description provided.";
        return description;
      },
      getDescriptionFromIds: function () {
        let newLine = "\r\n";
        let description = "";
        let descriptionFields = document.querySelectorAll(".description");
        descriptionFields.forEach((field) => {
          if (field.querySelector("button")) {
            //accordion item
            if (field.querySelector('input[type="file"]').getAttribute("url")) {
              description += "<<" + field.querySelector("button").innerText + ">>";
              description += newLine;
            }
          } else if (field.querySelector("select:not([multiple])")) {
            //single select
            if (field.querySelector("select").selectedOptions[0]?.value) {
              let label= field.querySelector("select").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description +=
                "A: "+field.querySelector("select").selectedOptions[0].value +
                newLine + newLine;
            }
          } else if (field.querySelector("select[multiple]")) {
              //multiple select
              if (field.querySelector("select").selectedOptions[0]?.value) {
                let label= field.querySelector("select").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
                description += "Q: "+label;
                description += newLine + "A: ";
                field
                  .querySelector("select")
                  .selectedOptions.forEach((option) => {
                    description += option.value + ", ";
                  });
                description = description.slice(0, -2); // Remove the last comma and space
                description += newLine + newLine;
              }
          } else if (field.querySelector('input[type="text"]')) {
            //text field
            if (field.querySelector("input").value) {
              let label= field.querySelector("input").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description += "A: "+field.querySelector("input").value + newLine + newLine;
            }
          } else if (field.querySelector('input[type="url"]')) {
            //url field
            if (field.querySelector("input").value) {
              let label= field.querySelector("input").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description += "A: "+field.querySelector("input").value + newLine + newLine;
            }
          }else if (field.querySelector('input[type="number"]')) {
            //number field
            if (field.querySelector("input").value) {
              let label= field.querySelector("input").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description += "A: "+field.querySelector("input").value + newLine + newLine;
            }
          } else if (field.querySelector('input[type="radio"]')) {
            //radio group
            if (field.querySelector('input[type="radio"]:checked')?.value) {
              let label= field.querySelector('input[type="radio"]:checked').getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description +=
                "A: "+field.querySelector('input[type="radio"]:checked')?.value +
                newLine + newLine;
            }
          } else if (field.querySelector("textarea")) {
            //textarea
            if (field.querySelector("textarea").value) {
              let label= field.querySelector("textarea").getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label;
              description += newLine;
              description += "A: "+field.querySelector("textarea").value + newLine+ newLine;
            }
          } else if (field.querySelector('input[type="file"]')) {
            //file input
            if (field.querySelector('input[type="file"]').getAttribute("url")) {
              let label= field.querySelector('input[type="file"]').getAttribute("sf-label") ?? field.querySelector("label").getAttribute("for");
              description += "Q: "+label + newLine;
                description +=
                  "A: "+field
                    .querySelector('input[type="file"]')
                    .getAttribute("url") + newLine+ newLine;
            }
          } else {
            description += "this field is not supported" + newLine;
            description += field.innerHTML;
          }
        });
        if (description === "") description = "No description provided.";
        return description;
      },
    },
    attachment: {
      uploadFile: async function (event, hostURL, projectName) {
        if (!hostURL) {
          TDForm.attachment.showError(
            event.target.id,
            "Hosting URL is not defined"
          );
          return;
        }
        if (event.target.files.length > 0) {
          let file = event.target.files[0];
          TDForm.attachment.showLoading();
          try {
            let response = await window.fetch(hostURL, {
              method: "POST",
              body: file,
              headers: {
                "Project-Name": projectName,
              },
            });
            if (!response.ok) {
              let responseText = response.statusText;
              responseText = await response.text();
              if (responseText === "") {
                responseText = "An error occurred while uploading the file.";
              }
              TDForm.attachment.hideLoading();
              TDForm.attachment.showError(event.target.id, responseText);
            } else {
              let responseText = await response.text();
              console.log(responseText);
              event.target.setAttribute("url", responseText);
              TDForm.attachment.hideLoading();
              TDForm.attachment.showSuccess(event.target.id);
            }
          } catch (e) {
            console.error(e);
            TDForm.attachment.showError(
              event.target.id,
              "An error occurred while uploading the file."
            );
            TDForm.attachment.hideLoading();
          }
        } else {
          event.target.setAttribute("url", "");
        }
      },
      removeFile: function (inputId) {
        let inputFile = document.getElementById(inputId);
        inputFile.removeAttribute("url");
        inputFile.removeAttribute("disabled");
        inputFile.value = "";
        let statusTag = document.querySelector(`#${inputId} + span`);
        if (statusTag !== null) {
          statusTag.innerHTML = "";
        }
      },
      showLoading: function () {
        showLoader();
      },
      hideLoading: function () {
        hideLoader();
      },
      showSuccess: function (inputId) {
        let statusTag = document.querySelector(`#${inputId} + span`);
        if (statusTag !== null) {
          let removeBtn = document.createElement("input");
          removeBtn.type = "button";
          removeBtn.value = "Remove";
          removeBtn.onclick = function () {
            TDForm.attachment.removeFile(inputId);
          };

          let inputFile = document.getElementById(inputId);
          inputFile.setAttribute("disabled", "disabled");

          statusTag.innerHTML = "";
          statusTag.appendChild(removeBtn);
          statusTag.classList.add("success");
          statusTag.classList.remove("error");
        } else {
          console.error("status tag not found!");
        }
      },
      showError: function (inputId, errorMessage) {
        let statusTag = document.querySelector(`#${inputId} + span`);
        if (statusTag !== null) {
          statusTag.innerHTML = errorMessage;
          statusTag.classList.add("error");
          statusTag.classList.remove("success");
          console.error(errorMessage);
        } else {
          console.error("status tag not found!");
          console.error(errorMessage);
        }
      },
    },
    AdjustRoles: function (e) {
      let selectedId = e.target.selectedIndex;
      let selectedType = e.target.options[e.target.selectedIndex].value;

      TDForm.private.CreateRoleOptions("globalRole", selectedType);
      TDForm.RegisterAdultChild(selectedId);
    },
    CheckSelectedRole: function (e) {
      if (document.getElementById("otherRole") === null) return;

      if (e.target[e.target.selectedIndex].value === "Other") {
        TDForm.private.showField("other-role-container");
        TDForm.private.MakeFieldMandatory("otherRole");
      } else {
        TDForm.private.hideField("other-role-container");
        TDForm.private.RemoveFieldMandatory("otherRole");
      }
    },
    RegisterTypeAndRole(region, typeSelectId, roleSelectId) {
      if (typeof region === "undefined") region = TDForm.defaultRegion;

      if (region == TDForm.currentRegion) return;

      TDForm.currentRegion = region;
      TDForm.TypeRole = new TypeRole(region);
      TDForm.private.CreateTypeOptions(typeSelectId);
      TDForm.private.CreateRoleOptions(roleSelectId, "");
      document
        .getElementById(typeSelectId)
        .addEventListener("change", (event) => {
          TDForm.AdjustRoles(event);
        });
      document
        .getElementById(roleSelectId)
        .addEventListener("change", (event) => {
          TDForm.CheckSelectedRole(event);
        });
      TDForm.private.addMultiSelectListener();
    },
    RegisterTypeAndRoleFor: function (
      language,
      variation,
      typeSelectId,
      roleSelectId
    ) {
      TDForm.TypeRole = new TypeRole(language, variation);
      TDForm.private.CreateTypeOptions(typeSelectId);
      TDForm.private.CreateRoleOptions(roleSelectId, "");
      document
        .getElementById(typeSelectId)
        .addEventListener("change", (event) => {
          TDForm.AdjustRoles(event);
        });
      document
        .getElementById(roleSelectId)
        .addEventListener("change", (event) => {
          TDForm.CheckSelectedRole(event);
        });
      TDForm.private.addMultiSelectListener();
    },
    RegisterAdultChild: function (selectedTypeId) {
      if (document.getElementById("adult-child-container") === null) return;

      let recordType = document.getElementById("recordType").value;
      if (AdultChildOptionShownByRoles.includes(selectedTypeId)) {
        TDForm.private.showField("adult-child-container");
        TDForm.private.MakeFieldMandatory("adultChild");
      } else {
        TDForm.private.hideField("adult-child-container");
        TDForm.private.RemoveFieldMandatory("adultChild");
      }
    },
    GetRoles: function (typeKey) {
      let typeRole = new TypeRole();
      if (Number.isInteger(typeKey)) {
        return typeRole.GetRolesById(typeKey);
      } else {
        return typeRole.GetRolesByName(typeKey);
      }
    },
    GetRegionFromUrl: function () {
      let host = window.location.host;
      let subdomain = host.split(".")[0];
      if (subdomain === "www" || TypeLocalization[subdomain] === undefined)
        return "global";
      else return subdomain;
    },
  };
}
